import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ServiceCenterService {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) {}
  url = environment.api;

  showServiceCenterId(id: string) {
    const urlfilteraccount = `${this.url}/api/v1/service-centers/${id}`;
    return this.http.get(urlfilteraccount);
  }
}
